export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6923.e16701fa.jpg";